import { render, staticRenderFns } from "./HomeSuitability.vue?vue&type=template&id=0211302c&scoped=true"
import script from "./HomeSuitability.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeSuitability.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HomeSuitability.vue?vue&type=style&index=0&id=0211302c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211302c",
  null
  
)

export default component.exports